import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { prop } from 'ramda';

import { media } from '@theme/media';
import { NARROW_CONTAINER_WIDTH } from '@components/blocks';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div<{ customStyles: FlattenSimpleInterpolation }>`
  padding: ${OFFSET.XL} ${OFFSET.S};
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  ${media.mobile} {
    justify-content: center;
    padding: ${OFFSET.XL} 0;
  }

  ${media.tablet} {
    margin-bottom: ${OFFSET.L};
    min-height: calc(var(--vh) - 320px);
  }

  ${prop('customStyles')};
`;

export const InnerContainer = styled.div`
  width: 100%;

  ${media.mobile} {
    padding: ${OFFSET.XS};
    width: 75%;
  }

  ${media.tablet} {
    width: ${NARROW_CONTAINER_WIDTH}px;
  }
`;
